import geometryLinks from './geometryLinks';

export default geometryLinks;
